/**
 * @file: ProductReferralFeeItemStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ProductReferralFeeItemStatus {
  AwaitingApproval = 'awaiting_approval',
  ApprovalFinished = 'approval_finished',
  Resolved = 'resolved',
}

export const ProductReferralFeeItemStatusValueSet = new Set([
  ProductReferralFeeItemStatus.AwaitingApproval,
  ProductReferralFeeItemStatus.ApprovalFinished,
  ProductReferralFeeItemStatus.Resolved,
]);
